// ----------------- COMMON API ENDPOINTS START -----------------
// GET ALL COLUMNS API ENDPOINTS FOR app.js
export const allTablesColumnsApiEndPoint = `admin/user-table-column`;
export const allTablesSelectedColumnsApiEndPoint = `admin/user-table-column/all-selected-columns`;

export const getLoginUserDetailsApiEndPoint = `admin/me`;

// Post selected columns api endpoint
export const setSelecteColumnsApiEndPoint = `admin/user-table-column`;
// ----------------- COMMON API ENDPOINTS END -----------------

// `````````````` Auth end points start ```````````````
// Login api endpoint
export const loginApiEndPoint = `admin/login`;
// `````````````` Auth end points End ```````````````

export const siteConfigurationApi = `admin/site/configuration`;

// `````````````` web user management api end points Start ```````````````
// GET WEB USER LIST API
export const webUsersApi = `admin/web-user`;
export const webUserMutationApi = `admin/web-user-mutations`;
export const webListDataExportApiEndPoint = `admin/web-user/export`;

// POST WEB USER LIST API
export const webListPostHeadingsApiEndPoint = `admin/user-table-column`;
// `````````````` web user management api end points End ```````````````

// `````````````` Admin User management api end points start ```````````````
export const subAdminListDataApiEndPoint = `admin/sub-admins`;
export const adminListDataApiEndPoint = `admin/admins`;
export const adminListDataExportApiEndPoint = `admin/sub-admins/export`;

// `````````````` Admin User management api end points end ```````````````

// `````````````` roles and permissions management api end points start ```````````````
export const rolesAndPermissions = `admin/roles`;

// `````````````` roles and permissions management api end points end ```````````````

// `````````````` product management api end points ```````````````

// MAPPINGS API
export const productGroupsMappingsApi = "admin/mappings/product-groups";
export const teamGroupTeamsMappingsApi = "admin/mappings/team-group-teams";
export const competitionGroupCompetitionsMappingsApi =
  "admin/mappings/competition-group-competitions";
export const SportGroupCategoryProductMappingsApi =
  "admin/mappings/sport-group-category-product";
export const productGenderSizeMappingsApi =
  "admin/mappings/product-gender-size";
export const productBrandsMappingsApi = "admin/mappings/product-brands";
export const productVersionsMappingsApi = "admin/mappings/product-versions";
// MAPPINGS API

// MASTER DATA API
export const sportsMasterDataApi = `admin/sports`;
export const teamGroupsMasterDataApi = `admin/team-groups`;
export const teamsMasterDataApi = `admin/teams`;
export const competitionGroupsMasterDataApi = `admin/competition-groups`;
export const competitionsMasterDataApi = `admin/competitions`;
export const eventsMasterDataApi = `admin/events`;
export const brandsMasterDataApi = `admin/brands`;
export const productGroupsMasterDataApi = `admin/product-groups`;
export const productCategoriesMasterDataApi = `admin/product-categories`;
export const productsMasterDataApi = `admin/products`;
export const editionsMasterDataApi = `admin/editions`;
export const termsMasterDataApi = `admin/terms`;
export const versionsMasterDataApi = `admin/versions`;
export const gendersMasterDataApi = `admin/genders`;
export const productSizesMasterDataApi = `admin/product-sizes`;
export const conditionsMasterDataApi = `admin/conditions`;
export const materialsMasterDataApi = `admin/materials`;
export const productClassesMasterDataApi = `admin/product-class`;
// MASTER DATA API

// `````````````` master data api end points ```````````````

// CURRENCY MANAGEMENT
export const currenciesApi = "admin/currencies";
export const currencyRatesApi = "admin/currency-rates";
export const currencyRateRefreshSchedulesApi =
  "admin/currency-rates/refresh-schedules";

// FINANCE MANAGEMENT
export const platformFeeApi = "admin/platform-fees";

// LANGUAGE MANAGEMENT
export const languagesApi = "admin/languages";
export const translationsApi = "admin/translations";

// REGION MANAGEMENT
export const countriesApi = "admin/countries";
export const countryManagementApi = "admin/country-management";

// CONTENT MANAGEMENT
export const bannersApi = "admin/banners";
export const backgroundsApi = "admin/backgrounds";
export const announcementsApi = "admin/announcements";
export const announcementPagesApi = "admin/announcement-pages";

// PROFILES
export const playersApi = "admin/players";
export const playerCareersApi = "admin/player-careers";
export const playerTypesApi = "admin/player-types";
export const eventParticipantsApi = "admin/event-participants";
export const teamNotableAchievementsApi = "admin/team-notable-achievements";

// BLOG MANAGEMENT
export const blogPostsApi = "admin/blog-posts";
export const blogCategoriesApi = "admin/blog-categories";

// JM INTERACTIVE
export const videoCategoriesApi = "admin/video-categories";
export const videoPostedApi = "admin/videos";
export const pictureCategoriesApi = "admin/picture-categories";
export const picturePostedApi = "admin/pictures";
export const achievementBadgesApi = "admin/achievement-badges";

// CONTACT SUPPORT TICKET
export const contactSupportsApi = "admin/contact-supports";
export const countTicketsApi = "admin/count-tickets";
export const contactSupportReasonsApi = "admin/contact-support-reasons";
export const downloadMediaApi = "admin/media";

// CITIES
export const citiesApi = "admin/cities";

// SETTING MANAGEMETN
export const settingsApi = "admin/settings";

// REVIEW MANAGEMENT
export const reviewsApi = "admin/reviews";

// SHIPPING MANAGEMENT
export const shippingStandard = "admin/shippings/matrix-standard";
export const shippingExpress = "admin/shippings/matrix-express";

// TRANSACTION MANAGEMENT
export const transactionsApi = "admin/transactions";

// AUDIT LOG
export const auditLogsApi = "admin/audit-log";
